import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductOverview from './pages/ProductOverview';
import Retailers from './pages/Retailers';
import About from './pages/About';
import Contact from './pages/Contact';
import Prices from './pages/Prices';
import Chocolate from './pages/Chocolate';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="produkter" element={<ProductOverview />} />
          <Route path="produkter/:category" element={<Products />} />
          <Route path="kollektion/chokolade" element={<Chocolate />} />
          <Route path="forhandlere" element={<Retailers />} />
          <Route path="hvem-er-jeg" element={<About />} />
          <Route path="priser" element={<Prices />} />
          <Route path="kontakt" element={<Contact />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
